export default __webpack_public_path__ + "static/media/go.96deba7c.svg";